// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter

import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { Details } from "@/app/oauth/details/details";
import { requireProjectPermission } from "@/lib/route-guards";

function OAuthDetailSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-4">
        <Skeleton className="h-8 w-8 rounded" />
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-6 w-16 rounded-full" />
      </div>
      <Skeleton className="h-24 rounded-lg" />
      <div className="grid grid-cols-1 gap-6">
        <Skeleton className="h-64 rounded-lg" />
        <Skeleton className="h-64 rounded-lg" />
      </div>
    </div>
  );
}

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/$oauthId"
)({
  component: () => (
    <Suspense fallback={<OAuthDetailSkeleton />}>
      <Details />
    </Suspense>
  ),
  beforeLoad: (ctx) =>
    requireProjectPermission(ctx, PROJECT.authProviders.read),
  loader: ({ params }) => ({
    crumb: `${params.oauthId}`,
  }),
});
